import React, { useImperativeHandle, useRef } from "react";
import { DragSource, DropTarget } from "react-dnd";
import InquiryCardContent from "./InquiryCardContent";
const InquiryCard = React.forwardRef(
	({ card, idx, isDragging, connectDragSource, connectDropTarget, connectDragPreview }, ref) => {
		const elementRef = useRef(null);
		connectDropTarget(elementRef);
		connectDragPreview(elementRef);
		//const opacity = isDragging ? 0 : 1
		useImperativeHandle(ref, () => ({
			getNode: () => elementRef.current,
		}));

		return (
			<>
				<li
					ref={elementRef}
					className={`c__card dynamic-type-${card.type?.toLowerCase()}`}
					data-ordernum={card.order}
					index={card.order}
				>
					<InquiryCardContent
						idx={idx}
						card={card}
						connectDragSource={connectDragSource}
					/>
				</li>
			</>
		);
	}
);

// export default InquiryCard;

export const ItemTypes = {
	CARD: "card",
};

export default DropTarget(
	ItemTypes.CARD,
	{
		hover(props, monitor, component) {
			if (!component) {
				return null;
			}

			const node = component.getNode();
			if (!node) {
				return null;
			}
			const dragIndex = monitor.getItem().index;
			const hoverIndex = props.index;

			if (dragIndex === hoverIndex) {
				return;
			}

			const hoverBoundingRect = node.getBoundingClientRect();
			const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
			const clientOffset = monitor.getClientOffset();
			const hoverClientY = clientOffset.y - hoverBoundingRect.top;

			if (
				(dragIndex < hoverIndex && hoverClientY > 0) ||
				(dragIndex > hoverIndex && hoverClientY > hoverMiddleY)
			) {
				return;
			}

			props.moveCard(dragIndex, hoverIndex);
			monitor.getItem().index = hoverIndex;
		},
	},
	(connect, monitor) => {
		return {
			connectDropTarget: connect.dropTarget(),
		};
	}
)(
	DragSource(
		ItemTypes.CARD,
		{
			beginDrag: (props, monitor, component) => {
				return { index: props.index };
			},
		},
		(connect, monitor) => {
			return {
				connectDragSource: connect.dragSource(),
				connectDragPreview: connect.dragPreview(),
				isDragging: monitor.isDragging(),
			};
		}
	)(InquiryCard)
);
